
import Logo from '@assets/iitk.png';
import React from 'react';
const IconPage = () => {
      return (
            <div className='flex justify-center items-center h-screen w-screen content-center'>
                  <img src={Logo} alt="No Data" className="h-96 w-96 animate-pulse opacity-50" />
            </div>
      )
}

export default React.memo(IconPage)
